import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class PinCodeToGetDetailsService {

  constructor(private http: HttpClient) { }

  async getPinDetails(pin) {
    try {
      let response = await this.http
        .get(`${appApiResources.pinCodeToGetDetails}${pin}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  getPinDetailsSub(pin) {
    return this.http
      .get(`${appApiResources.pinCodeToGetDetails}${pin}`)

  }

}
